import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchPageContent } from '@client/connectivity/api.cms';

export const DUCK_PROFILE_PAGE_KEY = 'duckProfilePageReducer';

const SET_PROFILE_PAGE_ERROR = 'SET_PROFILE_PAGE_ERROR';
const LOAD_PROFILE_PAGE_CMS = 'LOAD_PROFILE_PAGE_CMS';

/* REDUCER */
let defaultState = fromJS({
  pageData: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_PROFILE_PAGE_CMS: {
      return state.merge({
        pageData: fromJS(action.payload),
        errorMessage: '',
      });
    }
    case SET_PROFILE_PAGE_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadProfilePageCms() {
  return function (dispatch) {
    return fetchPageContent('profilePage').then((response) => {
      return dispatch({
        type: LOAD_PROFILE_PAGE_CMS,
        payload: response,
      });
    });
  };
}

export function loadProfilePageData() {
  return function (dispatch) {
    const profilePageDataPromises = [dispatch(loadProfilePageCms())];

    return Promise.all(profilePageDataPromises);
  };
}

/* SELECTORS */
export const selectProfilePageData = (state) => {
  return valIn(state[DUCK_PROFILE_PAGE_KEY], 'pageData');
};
